// utils/mapearONTOptions.ts
import { ONTOption } from "@/shared/interfaces";

interface ProductoUbicacion {
  series?: string[];
  producto_data?: {
    es_ont?: boolean;
    descripcion?: string;
    codigo?: string;
  };
}

export function mapearONTOptions(
  productos: ProductoUbicacion[] | undefined,
){
  if (!productos) return [];

  const opciones = productos
    .map((item) => {
      const series = item.series;
      if (!item.producto_data?.es_ont || !series?.length) return null;

      return series.map((serie) => {
        const [codigoSerie] = serie.split("-");
        return {
          name: `${item.producto_data?.descripcion} - ${codigoSerie}`,
          codigo: item.producto_data?.codigo,
          cantidad: "1",
          series: [serie],
        };
      });
    })
    .filter((x): x is any[] => x != null);

  return opciones.flat();
}